import React from 'react'

function DeleteClient({ ClientData }) {


  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Client will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Client Name :</b> {ClientData.ClientDisplayName}</li>
          </ul>
        </p>
      </div>
    </>
  )
}

export default DeleteClient